import { useHistory } from 'react-router'
import SumInsuredBreakdown from '../../../FinalReview/SumInsuredBreakdown'

const QuotesPendingSumInsuredBreakdown = () => {
	const history = useHistory()

	const onBack = () => {
		history.push('/rfq-status/quotes-pending/final-review')
	}
	const onProceed = () => {
		history.push('/quotes-in-progress')
	}
	const proceedBtnText = 'Next'

	return (
		<SumInsuredBreakdown onBack={onBack} onProceed={onProceed} proceedBtnText={proceedBtnText} />
	)
}

export default QuotesPendingSumInsuredBreakdown
